export async function jobberAccountName(state: string): Promise<{ account_name: string }> {
    const response = await fetch("/auth/jobber/account_name", {
        credentials: "include",
        headers: {
            "X-INTEGRATION-STATE": state,
        },
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch Jobber account name: ${response.status}`);
    }
    return response.json();
}

export async function jobberAuthorize(code: string | null): Promise<{ state: string }> {
    const params = new URLSearchParams();
    if (code) params.set("code", code);

    const response = await fetch(`/auth/jobber/authorize?${params}`, {
        method: "POST",
        credentials: "include",
    });
    if (!response.ok) {
        throw new Error(`Jobber authorization failed: ${response.status}`);
    }
    return response.json();
}

export async function jobberRedirectUrl(): Promise<{ redirect_url: string }> {
    const response = await fetch("/auth/jobber/redirect_url", {
        credentials: "include",
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch Jobber redirect URL: ${response.status}`);
    }
    return response.json();
}

export async function instagramAuthorize(
    code: string,
    state: string,
): Promise<{ state: string; username?: string }> {
    const params = new URLSearchParams();
    params.set("code", code);

    const response = await fetch(`/auth/instagram/authorize?${params}`, {
        method: "POST",
        credentials: "include",
        headers: {
            "X-INTEGRATION-STATE": state,
        },
    });
    if (!response.ok) {
        throw new Error(`Instagram authorization failed: ${response.status}`);
    }
    return response.json();
}

export async function instagramRedirectUrl(state: string): Promise<{ redirect_url: string }> {
    const response = await fetch("/auth/instagram/redirect_url", {
        credentials: "include",
        headers: {
            "X-INTEGRATION-STATE": state,
        },
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch Instagram redirect URL: ${response.status}`);
    }
    return response.json();
}
